[
  {
    "id": "fr-296",
    "name": "CLINIQUE JEANNE D'ARC - LES ORCHIDÉES",
    "address": {
      "id": "addr-fr-296",
      "address1": "RUE ALSACE LORRAINE",
      "city": "Le Port",
      "state": null,
      "postalCode": "97420",
      "country": "FR"
    },
    "headline": "CLINIQUE JEANNE D'ARC - LES ORCHIDÉES",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.clinifutur.net/",
    "email": "cja@clinifutur.net",
    "phone": null,
    "bookingUrl": null,
    "location": {
      "latitude": -20.9369,
      "longitude": 55.2962
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-298",
    "name": "CHU SITE SUD (SAINT PIERRE)",
    "address": {
      "id": "addr-fr-298",
      "address1": "AVENUE FRANCOIS MITTERRAND",
      "city": "Saint Pierre",
      "state": null,
      "postalCode": "97448",
      "country": "FR"
    },
    "headline": "CHU SITE SUD (SAINT PIERRE)",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chu-reunion.fr/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": {
      "latitude": -21.0371,
      "longitude": 55.71180000000004
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-2097",
    "name": "Centre de Fertilité d’Armor - St Brieuc",
    "address": {
      "id": "addr-fr-2097",
      "address1": "10 rue Marcel Proust",
      "city": "St Brieuc",
      "state": null,
      "postalCode": "22000",
      "country": "FR"
    },
    "headline": "Centre de Fertilité d’Armor - St Brieuc",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://ghtarmor.bzh/centre-de-fertilite-darmor/",
    "email": "centre.fertilite.armor@armorsante.bzh",
    "phone": null,
    "bookingUrl": null,
    "location": {
      "latitude": 48.492601000454506,
      "longitude": -2.750848690514815
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-2065",
    "name": "Centre d'Assistance Médicale à la Procréation Sainte Anne - Strasbourg",
    "address": {
      "id": "addr-fr-2065",
      "address1": "Rue Philippe Thys",
      "city": "Strasbourg",
      "state": null,
      "postalCode": "67000",
      "country": "FR"
    },
    "headline": "Centre d'Assistance Médicale à la Procréation Sainte Anne - Strasbourg",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "PGT"
    ],
    "website": "https://www.ghsv.org/",
    "email": "secr.amp.sa@ghsv.org",
    "phone": null,
    "bookingUrl": null,
    "location": {
      "latitude": 48.61506226263607,
      "longitude": 7.789320094525099
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-219",
    "name": "HÔPITAL PRIVE LA CHATAIGNERAIE",
    "address": {
      "id": "addr-fr-219",
      "address1": "59 RUE DE LA CHATAIGNERAIE",
      "city": "Beaumont",
      "state": "Auvergne-Rhône-Alpes",
      "postalCode": "63110",
      "country": "FR"
    },
    "headline": "HÔPITAL PRIVE LA CHATAIGNERAIE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.elsan.care/fr/hopital-prive-chataigneraie",
    "email": "laboratoire.beaumont@genbio.fr",
    "phone": "04 73 15 06 06",
    "bookingUrl": null,
    "location": {
      "latitude": 45.7502,
      "longitude": 3.076469999999972
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-229",
    "name": "HÔPITAL FEMME MÈRE ENFANT",
    "address": {
      "id": "addr-fr-229",
      "address1": "59 BOULEVARD PINEL",
      "city": "Bron",
      "state": "Auvergne-Rhône-Alpes",
      "postalCode": "69677",
      "country": "FR"
    },
    "headline": "HÔPITAL FEMME MÈRE ENFANT",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chu-lyon.fr/hopital-femme-mere-enfant",
    "email": "hfme.preservationfertilite@chu-lyon.fr",
    "phone": "-",
    "bookingUrl": null,
    "location": {
      "latitude": 45.7319,
      "longitude": 4.888289999999984
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-217",
    "name": "HÔPITAL ESTAING CHU63",
    "address": {
      "id": "addr-fr-217",
      "address1": "1 PLACE LUCIE AUBRAC",
      "city": "Clermont Ferrand",
      "state": "Auvergne-Rhône-Alpes",
      "postalCode": "63003",
      "country": "FR"
    },
    "headline": "HÔPITAL ESTAING CHU63",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chu-clermontferrand.fr/liste-services/amp-cecos",
    "email": "secretariat.amp.fiv@chu-clermontferrand.fr",
    "phone": "04 73 75 01 25",
    "bookingUrl": null,
    "location": {
      "latitude": 45.7845,
      "longitude": 3.1095699999999624
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-239",
    "name": "CENTRE HOSPITALIER ALPES LEMAN - LABORATOIRE ORIADE NOVIALE",
    "address": {
      "id": "addr-fr-239",
      "address1": "558 ROUTE DE FINDROL",
      "city": "Contamine Sur Arve",
      "state": "Auvergne-Rhône-Alpes",
      "postalCode": "74130",
      "country": "FR"
    },
    "headline": "CENTRE HOSPITALIER ALPES LEMAN - LABORATOIRE ORIADE NOVIALE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "http://www.centreamp74.com",
    "email": "labo.contamine@oriade.fr",
    "phone": "04 50 82 23 95",
    "bookingUrl": null,
    "location": {
      "latitude": 46.147,
      "longitude": 6.319819999999936
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-231",
    "name": "CLINIQUE DU VAL D'OUEST VENDOME",
    "address": {
      "id": "addr-fr-231",
      "address1": "39 CHEMIN DE LA VERNIQUE",
      "city": "Ecully",
      "state": "Auvergne-Rhône-Alpes",
      "postalCode": "69130",
      "country": "FR"
    },
    "headline": "CLINIQUE DU VAL D'OUEST VENDOME",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.institut-rhonealpin.com",
    "email": "secretariat@irh-valdouest.fr",
    "phone": "04 72 19 33 48",
    "bookingUrl": null,
    "location": {
      "latitude": 45.7682,
      "longitude": 4.781839999999988
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-120",
    "name": "Hôpital Privé Drome Ardèche - Clinique Pasteur",
    "address": {
      "id": "addr-fr-120",
      "address1": "294 BOULEVARD GENERAL DE GAULLE",
      "city": "Guilherand Granges",
      "state": "Auvergne-Rhône-Alpes",
      "postalCode": "07500",
      "country": "FR"
    },
    "headline": "Hôpital Privé Drome Ardèche - Clinique Pasteur",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://hopital-prive-drome-ardeche-valence-guilherand-granges.ramsaysante.fr/",
    "email": "hpda.communication@ramsaygds.fr",
    "phone": "04 75 82 31 70 / 04 75 56 21 20",
    "bookingUrl": null,
    "location": {
      "latitude": 44.9342,
      "longitude": 4.883050000000026
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-173",
    "name": "HÔPITAL NORD CHU38",
    "address": {
      "id": "addr-fr-173",
      "address1": "BOULEVARD DE LA CHANTOURNE",
      "city": "La Tronche",
      "state": "Auvergne-Rhône-Alpes",
      "postalCode": "38700",
      "country": "FR"
    },
    "headline": "HÔPITAL NORD CHU38",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs",
      "PGT"
    ],
    "website": "https://www.chu-grenoble.fr/nord",
    "email": "AMPCHUGA@chu-grenoble.fr",
    "phone": "04 76 76 59 09",
    "bookingUrl": null,
    "location": {
      "latitude": 45.1968,
      "longitude": 5.748829999999998
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-235",
    "name": "HÔPITAL PRIVE NATECIA",
    "address": {
      "id": "addr-fr-235",
      "address1": "22 AVENUE ROCKEFELLER",
      "city": "Lyon 8eme",
      "state": "Auvergne-Rhône-Alpes",
      "postalCode": "69008",
      "country": "FR"
    },
    "headline": "HÔPITAL PRIVE NATECIA",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.fiv-lyon.fr",
    "email": "fertily.natecia@noalys.com",
    "phone": "04 78 00 33 34",
    "bookingUrl": null,
    "location": {
      "latitude": 45.7415,
      "longitude": 4.883640000000014
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-179",
    "name": "CONSULTATION DE GYNECOLOGIE CENTRE HOSPITALIER DE ROANNE",
    "address": {
      "id": "addr-fr-179",
      "address1": "28 RUE DE CHARLIEU",
      "city": "Roanne",
      "state": "Auvergne-Rhône-Alpes",
      "postalCode": "42328",
      "country": "FR"
    },
    "headline": "CONSULTATION DE GYNECOLOGIE CENTRE HOSPITALIER DE ROANNE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.ch-roanne.fr/service-18-gynecologie-obstetrique.html",
    "email": "service.pma@ch-roanne.fr",
    "phone": "04 77 44 32 87",
    "bookingUrl": null,
    "location": {
      "latitude": 46.0431,
      "longitude": 4.078070000000025
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-175",
    "name": "CENTRE AMP GRENOBLE BELLEDONNE",
    "address": {
      "id": "addr-fr-175",
      "address1": "75 AV GABRIEL PERI",
      "city": "Saint Martin D'Heres",
      "state": "Auvergne-Rhône-Alpes",
      "postalCode": "38400",
      "country": "FR"
    },
    "headline": "CENTRE AMP GRENOBLE BELLEDONNE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.fiv.fr/pma-clinique-belledonne/",
    "email": "gynecofiv@wanadoo.fr",
    "phone": "04 76 54 70 05",
    "bookingUrl": null,
    "location": {
      "latitude": 45.1862,
      "longitude": 5.760189999999966
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-177",
    "name": "HÔPITAL NORD CHU42",
    "address": {
      "id": "addr-fr-177",
      "address1": "AVENUE ALBERT RAIMOND",
      "city": "Saint Priest En Jarez",
      "state": "Auvergne-Rhône-Alpes",
      "postalCode": "42277",
      "country": "FR"
    },
    "headline": "HÔPITAL NORD CHU42",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chu-st-etienne.fr/",
    "email": "amp@chu-st-etienne.fr",
    "phone": "04 77 82 82 60",
    "bookingUrl": null,
    "location": {
      "latitude": 45.4748,
      "longitude": 4.369640000000004
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-233",
    "name": "CENTRE PROCREO",
    "address": {
      "id": "addr-fr-233",
      "address1": "173 RUE LEON BLUM",
      "city": "Villeurbanne",
      "state": "Auvergne-Rhône-Alpes",
      "postalCode": "69100",
      "country": "FR"
    },
    "headline": "CENTRE PROCREO",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.medipolelyonvilleurbanne.fr/",
    "email": "docteur.divry@procreo.fr",
    "phone": "04 78 93 89 70",
    "bookingUrl": null,
    "location": {
      "latitude": 45.7606,
      "longitude": 4.9062999999999874
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-142",
    "name": "CHU JEAN MINJOZ - CENTRE AMP",
    "address": {
      "id": "addr-fr-142",
      "address1": "3 BOULEVARD FLEMING",
      "city": "Besancon",
      "state": "Bourgogne-Franche-Comté",
      "postalCode": "25030",
      "country": "FR"
    },
    "headline": "CHU JEAN MINJOZ - CENTRE AMP",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://www.chu-besancon.fr",
    "email": "fiv@chu-besancon.fr",
    "phone": "03 81 21 88 04",
    "bookingUrl": null,
    "location": {
      "latitude": 47.2255,
      "longitude": 5.962729999999965
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-140",
    "name": "LABORATOIRE CBM 25",
    "address": {
      "id": "addr-fr-140",
      "address1": "4 RUE AUGUSTE RODIN",
      "city": "Besancon",
      "state": "Bourgogne-Franche-Comté",
      "postalCode": "25000",
      "country": "FR"
    },
    "headline": "LABORATOIRE CBM 25",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.cbm25.fr",
    "email": "veronique.seneclauze-seguin@pma-fc.fr",
    "phone": "03 81 41 80 10",
    "bookingUrl": null,
    "location": {
      "latitude": 47.2157,
      "longitude": 5.979190000000017
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-136",
    "name": "HÔPITAL LE BOCAGE CHRU DIJON",
    "address": {
      "id": "addr-fr-136",
      "address1": "1 BOULEVARD JEANNE D'ARC",
      "city": "Dijon",
      "state": "Bourgogne-Franche-Comté",
      "postalCode": "21079",
      "country": "FR"
    },
    "headline": "HÔPITAL LE BOCAGE CHRU DIJON",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://amp.chu-dijon.fr",
    "email": "amp@chu-dijon.fr",
    "phone": "03 80 29 36 14",
    "bookingUrl": null,
    "location": {
      "latitude": 47.3221,
      "longitude": 5.06528000000003
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-146",
    "name": "CHRU BREST SITE HÔPITAL MORVAN",
    "address": {
      "id": "addr-fr-146",
      "address1": "2 AVENUE FOCH",
      "city": "Brest",
      "state": "Bretagne",
      "postalCode": "29200",
      "country": "FR"
    },
    "headline": "CHRU BREST SITE HÔPITAL MORVAN",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.fiv.chu-brest.fr",
    "email": "centre.fiv-amp@chu-brest.fr",
    "phone": "02 98 22 32 22",
    "bookingUrl": null,
    "location": {
      "latitude": 48.39282818747923,
      "longitude": -4.487528307418936
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-148",
    "name": "LABO PMA CERBALLIANCE",
    "address": {
      "id": "addr-fr-148",
      "address1": "375 rue Ernestine de Tremaudan",
      "city": "Brest",
      "state": "Bretagne",
      "postalCode": "29200",
      "country": "FR"
    },
    "headline": "LABO PMA CERBALLIANCE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://cfo29.fr/",
    "email": "laboamp.finistere@cerballiance.fr",
    "phone": "02 98 31 30 03",
    "bookingUrl": null,
    "location": {
      "latitude": 48.4007,
      "longitude": -4.489059999999995
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-61",
    "name": "GHBS HOPITAL DU SCORFF",
    "address": {
      "id": "addr-fr-61",
      "address1": "5 AVENUE DE CHOISEUL",
      "city": "Lorient",
      "state": "Bretagne",
      "postalCode": "56322",
      "country": "FR"
    },
    "headline": "GHBS HOPITAL DU SCORFF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.ghbs.bzh/information-transversale/annuaire-des-services/detail-d-un-service-270/assistance-medicale-a-la-procreation-amp-6.html?cHash=e63b4538e961751b86f805b46e59133b",
    "email": "v.julou@ghbs.bzh",
    "phone": "02 97 06 92 85",
    "bookingUrl": null,
    "location": {
      "latitude": 47.754,
      "longitude": -3.357409999999959
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-167",
    "name": "CENTRE AMP CLINIQUE MUTUALISTE LA SAGESSE",
    "address": {
      "id": "addr-fr-167",
      "address1": "4 PLACE SAINT GUENOLE",
      "city": "Rennes",
      "state": "Bretagne",
      "postalCode": "35043",
      "country": "FR"
    },
    "headline": "CENTRE AMP CLINIQUE MUTUALISTE LA SAGESSE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "http://clinique-rennes.fr/",
    "email": "sec.amp.lasagesse@hospigrandouest.fr",
    "phone": "02 99 85 75 20",
    "bookingUrl": null,
    "location": {
      "latitude": 48.1009,
      "longitude": -1.7117000000000644
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-165",
    "name": "CHRU RENNES SITE HÔPITAL SUD",
    "address": {
      "id": "addr-fr-165",
      "address1": "16 BOULEVARD DE BULGARIE",
      "city": "Rennes",
      "state": "Bretagne",
      "postalCode": "35200",
      "country": "FR"
    },
    "headline": "CHRU RENNES SITE HÔPITAL SUD",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chu-rennes.fr/",
    "email": null,
    "phone": "02 99 26 59 11",
    "bookingUrl": null,
    "location": {
      "latitude": 48.0845,
      "longitude": -1.6533500000000458
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-171",
    "name": "POLE SANTÉ LÉONARD DE VINCI",
    "address": {
      "id": "addr-fr-171",
      "address1": "1 AVENUE DU PROFESSEUR ALEXANDRE MINKOWSKI",
      "city": "Chambray Les Tours",
      "state": "Centre-Val de Loire",
      "postalCode": "37175",
      "country": "FR"
    },
    "headline": "POLE SANTÉ LÉONARD DE VINCI",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.pslv.fr/",
    "email": null,
    "phone": "02 47 22 21 11",
    "bookingUrl": null,
    "location": {
      "latitude": 47.335,
      "longitude": 0.6901169999999865
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-144",
    "name": "CH DREUX",
    "address": {
      "id": "addr-fr-144",
      "address1": "44 AVENUE PRESIDENT JOHN-FITZGERALD KENNEDY",
      "city": "Dreux",
      "state": "Centre-Val de Loire",
      "postalCode": "28102",
      "country": "FR"
    },
    "headline": "CH DREUX",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://www.ch-dreux.fr/",
    "email": "pmaeure-et-loir@ch-dreux.fr",
    "phone": "02 37 51 54 60",
    "bookingUrl": null,
    "location": {
      "latitude": 48.729,
      "longitude": 1.3858999999999924
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-189",
    "name": "CHRO HÔPITAL LA SOURCE",
    "address": {
      "id": "addr-fr-189",
      "address1": "14 AVENUE DE L'HOPITAL",
      "city": "Orleans",
      "state": "Centre-Val de Loire",
      "postalCode": "45100",
      "country": "FR"
    },
    "headline": "CHRO HÔPITAL LA SOURCE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.centrepma-orleans.fr/",
    "email": null,
    "phone": "02 38 74 45 68",
    "bookingUrl": null,
    "location": {
      "latitude": 47.8355,
      "longitude": 1.9226999999999634
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-191",
    "name": "PÔLE SANTÉ ORELIANCE",
    "address": {
      "id": "addr-fr-191",
      "address1": "555 AVENUE JACQUELINE AURIOL",
      "city": "Saran",
      "state": "Centre-Val de Loire",
      "postalCode": "45770",
      "country": "FR"
    },
    "headline": "PÔLE SANTÉ ORELIANCE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://oreliance.com/",
    "email": "laboratoire.amp@nataliance.fr",
    "phone": "02 38 42 18 00",
    "bookingUrl": null,
    "location": {
      "latitude": 47.9406,
      "longitude": 1.8799599999999828
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-169",
    "name": "CHRU BRETONNEAU TOURS",
    "address": {
      "id": "addr-fr-169",
      "address1": "2 BOULEVARD TONNELLE",
      "city": "Tours",
      "state": "Centre-Val de Loire",
      "postalCode": "37044",
      "country": "FR"
    },
    "headline": "CHRU BRETONNEAU TOURS",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://www.chu-tours.fr/medecine-et-biologie-de-la-reproduction/",
    "email": "guerif@med.univ-tours.fr",
    "phone": "02 47 47 47 46",
    "bookingUrl": null,
    "location": {
      "latitude": 47.3872,
      "longitude": 0.6695549999999457
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-311",
    "name": "POLYCLINIQUE DE BEZANNES",
    "address": {
      "id": "addr-fr-311",
      "address1": "109 RUE LOUIS VICTOR DE BROGLIE",
      "city": "Bezannes",
      "state": "Grand Est",
      "postalCode": "51430",
      "country": "FR"
    },
    "headline": "POLYCLINIQUE DE BEZANNES",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "http://www.courlancy-sante.com/reims-bezannes",
    "email": null,
    "phone": "03 52 15 16 17",
    "bookingUrl": null,
    "location": {
      "latitude": 49.21841194557666,
      "longitude": 4.001480861382247
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-122",
    "name": "Centre Clinico-Biologique du CH de Charleville-Mézières",
    "address": {
      "id": "addr-fr-122",
      "address1": "45 AVENUE DE MANCHESTER",
      "city": "Charleville Mezieres",
      "state": "Grand Est",
      "postalCode": "08011",
      "country": "FR"
    },
    "headline": "Centre Clinico-Biologique du CH de Charleville-Mézières",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.hopitaux-nord-ardenne.fr/services/laboratoire/",
    "email": "brigitte.henon@ch-nord-ardennes.fr",
    "phone": "03 24 58 73 93",
    "bookingUrl": null,
    "location": {
      "latitude": 49.7617,
      "longitude": 4.695119999999974
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-271",
    "name": "POLYCLINIQUE LA LIGNE BLEUE",
    "address": {
      "id": "addr-fr-271",
      "address1": "9 AVENUE DU ROSE POIRIER",
      "city": "Epinal",
      "state": "Grand Est",
      "postalCode": "88060",
      "country": "FR"
    },
    "headline": "POLYCLINIQUE LA LIGNE BLEUE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "http://www.analysis.fr",
    "email": "contact@analysis.fr",
    "phone": "03 29 68 63 33",
    "bookingUrl": null,
    "location": {
      "latitude": 48.2002,
      "longitude": 6.463709999999992
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-203",
    "name": "CHR METZ THIONVILLE - CENTRE AMP",
    "address": {
      "id": "addr-fr-203",
      "address1": "1 ALLÉE DU CHATEAU",
      "city": "Metz",
      "state": "Grand Est",
      "postalCode": "57085",
      "country": "FR"
    },
    "headline": "CHR METZ THIONVILLE - CENTRE AMP",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chr-metz-thionville.fr/",
    "email": "amp.secretariat.mercy@chr-metz-thionville.fr",
    "phone": "03 87 34 54 83",
    "bookingUrl": null,
    "location": {
      "latitude": 49.0843,
      "longitude": 6.242439999999988
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-1281",
    "name": "HÔPITAL ÉMILE MULLER",
    "address": {
      "id": "addr-fr-1281",
      "address1": "20 RUE DU DR LAENNEC",
      "city": "Mulhouse",
      "state": "Grand Est",
      "postalCode": "68051",
      "country": "FR"
    },
    "headline": "HÔPITAL ÉMILE MULLER",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.ghrmsa.fr/",
    "email": "secr-labomicrobio@ch-mulhouse.fr",
    "phone": "03 89 64 61 16",
    "bookingUrl": null,
    "location": {
      "latitude": 47.7262,
      "longitude": 7.343820000000051
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-199",
    "name": "CHRU DE NANCY – SITE MATERNITE - CENTRE AMP - Bâtiment Délivoria (2e étage)",
    "address": {
      "id": "addr-fr-199",
      "address1": "10, rue du Dr Heydenreich",
      "city": "Nancy",
      "state": "Grand Est",
      "postalCode": "54000",
      "country": "FR"
    },
    "headline": "CHRU DE NANCY – SITE MATERNITE - CENTRE AMP - Bâtiment Délivoria (2e étage)",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://www.chru-nancy.fr/index.php/offre-de-soins/amp-reproduction",
    "email": "amp@chu-nancy.fr",
    "phone": "03 83 34 44 26",
    "bookingUrl": null,
    "location": {
      "latitude": 48.6813,
      "longitude": 6.190249999999992
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-201",
    "name": "POLYCLINIQUE MAJORELLE",
    "address": {
      "id": "addr-fr-201",
      "address1": "95 RUE AMBROISE PARÉ",
      "city": "Nancy",
      "state": "Grand Est",
      "postalCode": "54000",
      "country": "FR"
    },
    "headline": "POLYCLINIQUE MAJORELLE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.elsan.care/fr/polyclinique-majorelle",
    "email": null,
    "phone": "03 83 95 79 71",
    "bookingUrl": null,
    "location": {
      "latitude": 48.701,
      "longitude": 6.144580000000019
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-197",
    "name": "HÔPITAL MAISON BLANCHE CHU REIMS",
    "address": {
      "id": "addr-fr-197",
      "address1": "45 RUE COGNACQ JAY",
      "city": "Reims",
      "state": "Grand Est",
      "postalCode": "51092",
      "country": "FR"
    },
    "headline": "HÔPITAL MAISON BLANCHE CHU REIMS",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chu-reims.fr",
    "email": null,
    "phone": "03 26 78 77 50",
    "bookingUrl": null,
    "location": {
      "latitude": 49.2316,
      "longitude": 4.01891999999998
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-57",
    "name": "POLYCLINIQUE DE COURLANCY",
    "address": {
      "id": "addr-fr-57",
      "address1": "38 RUE DE COURLANCY",
      "city": "Reims",
      "state": "Grand Est",
      "postalCode": "51100",
      "country": "FR"
    },
    "headline": "POLYCLINIQUE DE COURLANCY",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "http://www.courlancy-sante.com/",
    "email": "centre-pma@wanadoo.fr",
    "phone": "03 26 77 26 77",
    "bookingUrl": null,
    "location": {
      "latitude": 49.2454,
      "longitude": 4.017979999999966
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-225",
    "name": "CMCO - CENTRE MEDICO-CHIRURGICAL OBSTÉTRIQUE",
    "address": {
      "id": "addr-fr-225",
      "address1": "19 RUE LOUIS PASTEUR",
      "city": "Schiltigheim",
      "state": "Grand Est",
      "postalCode": "67303",
      "country": "FR"
    },
    "headline": "CMCO - CENTRE MEDICO-CHIRURGICAL OBSTÉTRIQUE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://www.chru-strasbourg.fr/Centre-Medico-chirurgical-Obstetrique-CMCO",
    "email": "amp.secretariat@chru-strasbourg.fr",
    "phone": "03 88 11 67 68",
    "bookingUrl": null,
    "location": {
      "latitude": 48.6006,
      "longitude": 7.7512400000000525
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-305",
    "name": "C.H.U. DE POINTE A PITRE/ABYMES",
    "address": {
      "id": "addr-fr-305",
      "address1": "ROUTE DE CHAUVEL",
      "city": "Les Abymes",
      "state": "Guadeloupe",
      "postalCode": "97139",
      "country": "FR"
    },
    "headline": "C.H.U. DE POINTE A PITRE/ABYMES",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chu-guadeloupe.fr/",
    "email": "secretariat.pma@chu-guadeloupe.fr",
    "phone": "05 90 93 46 43",
    "bookingUrl": null,
    "location": {
      "latitude": 16.2705,
      "longitude": -61.50459999999998
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-103",
    "name": "CLINIQUE VICTOR PAUCHET DE BUTLER - PÔLE FEMMES ENFANTS",
    "address": {
      "id": "addr-fr-103",
      "address1": "2 AVENUE D'IRLANDE",
      "city": "Amiens",
      "state": "Hauts-de-France",
      "postalCode": "80094",
      "country": "FR"
    },
    "headline": "CLINIQUE VICTOR PAUCHET DE BUTLER - PÔLE FEMMES ENFANTS",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.cliniquevictorpauchet.fr/aide-medicale-a-la-procreation",
    "email": "amp@picardieweb.com",
    "phone": "03 22 33 40 70",
    "bookingUrl": null,
    "location": {
      "latitude": 49.8714,
      "longitude": 2.2953999999999724
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-261",
    "name": "CHU AMIENS PICARDIE",
    "address": {
      "id": "addr-fr-261",
      "address1": "Site Sud - 1 rond point du Professeur Cabrol - Bâtiment Centre de biologie humaine",
      "city": "Amiens Cedex 1",
      "state": "Hauts-de-France",
      "postalCode": "80054",
      "country": "FR"
    },
    "headline": "CHU AMIENS PICARDIE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://www.chu-amiens.fr",
    "email": "bdr-amp.secretariat@chu-amiens.fr",
    "phone": "03 22 08 73 70",
    "bookingUrl": null,
    "location": {
      "latitude": 49.87683100113802,
      "longitude": 2.2557926829887722
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-215",
    "name": "CH CALAIS",
    "address": {
      "id": "addr-fr-215",
      "address1": "1601 BOULEVARD DES JUSTES",
      "city": "Calais",
      "state": "Hauts-de-France",
      "postalCode": "62107",
      "country": "FR"
    },
    "headline": "CH CALAIS",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://www.docvadis.fr/centre-amp-calais",
    "email": "secretariat-amp@ch-calais.fr",
    "phone": "03 21 46 35 51",
    "bookingUrl": null,
    "location": {
      "latitude": 50.9408,
      "longitude": 1.8928300000000036
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-299",
    "name": "CENTRE HOSPITALIER DE LENS",
    "address": {
      "id": "addr-fr-299",
      "address1": "99 ROUTE DE LA BASSEE",
      "city": "Lens",
      "state": "Hauts-de-France",
      "postalCode": "62307",
      "country": "FR"
    },
    "headline": "CENTRE HOSPITALIER DE LENS",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.ght-artois.fr/trouvez-un-service/femme-mere-enfant/article/assistance-medicale-a-la-procreation",
    "email": "sec.amp@ch-lens.fr",
    "phone": "03 21 69 17 95",
    "bookingUrl": null,
    "location": {
      "latitude": 50.4386,
      "longitude": 2.821040000000039
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-205",
    "name": "HOP JEANNE DE FLANDRE CHR LILLE",
    "address": {
      "id": "addr-fr-205",
      "address1": "AVENUE EUGÈNE AVINÉE",
      "city": "Lille",
      "state": "Hauts-de-France",
      "postalCode": "59000",
      "country": "FR"
    },
    "headline": "HOP JEANNE DE FLANDRE CHR LILLE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://www.chru-lille.fr",
    "email": "secretariat.amp@chru-lille.fr",
    "phone": "03 20 44 68 97",
    "bookingUrl": null,
    "location": {
      "latitude": 50.60661595307418,
      "longitude": 3.03301882118367
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-207",
    "name": "HOPITAL PRIVE LE BOIS",
    "address": {
      "id": "addr-fr-207",
      "address1": "44 AVENUE MARX DORMOY",
      "city": "Lille",
      "state": "Hauts-de-France",
      "postalCode": "59000",
      "country": "FR"
    },
    "headline": "HOPITAL PRIVE LE BOIS",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.biolille.fr",
    "email": "i.tiberghien@ramsaygds.fr",
    "phone": "03 59 75 75 75",
    "bookingUrl": null,
    "location": {
      "latitude": 50.6491,
      "longitude": 3.0042100000000573
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-209",
    "name": "POLYCLINIQUE DU PARC",
    "address": {
      "id": "addr-fr-209",
      "address1": "62 RUE HENRI BARBUSSE",
      "city": "Saint Saulve",
      "state": "Hauts-de-France",
      "postalCode": "59880",
      "country": "FR"
    },
    "headline": "POLYCLINIQUE DU PARC",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.pma-stsaulve.fr",
    "email": "ampsaintsaulve@biopath.fr",
    "phone": "03 27 23 16 66",
    "bookingUrl": null,
    "location": {
      "latitude": 50.371,
      "longitude": 3.5481099999999515
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-211",
    "name": "CH GHPSO SENLIS",
    "address": {
      "id": "addr-fr-211",
      "address1": "14 AVENUE PAUL ROUGÉ",
      "city": "Senlis",
      "state": "Hauts-de-France",
      "postalCode": "60309",
      "country": "FR"
    },
    "headline": "CH GHPSO SENLIS",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.ghpso.fr/",
    "email": "pma.senlis@gmail.com",
    "phone": "03 44 21 73 24",
    "bookingUrl": null,
    "location": {
      "latitude": 49.196,
      "longitude": 2.574820000000045
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-287",
    "name": "CENTRE MEDICO CHIRURGICAL FLOREAL",
    "address": {
      "id": "addr-fr-287",
      "address1": "40 RUE FLOREAL",
      "city": "Bagnolet",
      "state": "Île-de-France",
      "postalCode": "93170",
      "country": "FR"
    },
    "headline": "CENTRE MEDICO CHIRURGICAL FLOREAL",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.amp93.com/",
    "email": "floreal@gmail.com",
    "phone": "01 48 97 50 32",
    "bookingUrl": null,
    "location": {
      "latitude": 48.8785,
      "longitude": 2.4311400000000276
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-283",
    "name": "HU PARIS SITE JEAN VERDIER APHP",
    "address": {
      "id": "addr-fr-283",
      "address1": "AVENUE DU 14 JUILLET",
      "city": "Bondy",
      "state": "Île-de-France",
      "postalCode": "93143",
      "country": "FR"
    },
    "headline": "HU PARIS SITE JEAN VERDIER APHP",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://chu93.aphp.fr/",
    "email": "secretariat-medical.sec-amp.jvr@aphp.fr",
    "phone": "01 48 02 60 30",
    "bookingUrl": null,
    "location": {
      "latitude": 48.9096,
      "longitude": 2.4908399999999347
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-273",
    "name": "HU PARIS SUD SITE ANTOINE BECLERE APHP",
    "address": {
      "id": "addr-fr-273",
      "address1": "157 rue de la porte de Trivaux",
      "city": "Clamart",
      "state": "Île-de-France",
      "postalCode": "92140",
      "country": "FR"
    },
    "headline": "HU PARIS SUD SITE ANTOINE BECLERE APHP",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs",
      "PGT"
    ],
    "website": "http://hopital-antoine-beclere.aphp.fr/",
    "email": "accueil.amp@aphp.fr",
    "phone": "01 45 37 40 53",
    "bookingUrl": null,
    "location": {
      "latitude": 48.7899,
      "longitude": 2.2537199999999302
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-291",
    "name": "CHI DE CRETEIL",
    "address": {
      "id": "addr-fr-291",
      "address1": "40 AVENUE DE VERDUN",
      "city": "Creteil",
      "state": "Île-de-France",
      "postalCode": "94010",
      "country": "FR"
    },
    "headline": "CHI DE CRETEIL",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chicreteil.fr/",
    "email": "ampsecr@chicreteil.fr",
    "phone": "01 41 78 40 44",
    "bookingUrl": null,
    "location": {
      "latitude": 48.7976,
      "longitude": 2.4645000000000437
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-316",
    "name": "CLINIQUE CLAUDE BERNARD",
    "address": {
      "id": "addr-fr-316",
      "address1": "9 AVENUE LOUIS ARMAND",
      "city": "Ermont",
      "state": "Île-de-France",
      "postalCode": "95120",
      "country": "FR"
    },
    "headline": "CLINIQUE CLAUDE BERNARD",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://clinique-claude-bernard-ermont.ramsaysante.fr/",
    "email": "gynecocormeilles@orange.fr",
    "phone": "01 34 50 36 36",
    "bookingUrl": null,
    "location": {
      "latitude": 48.9813,
      "longitude": 2.2644299999999475
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-285",
    "name": "LABORATOIRE CLEMENT",
    "address": {
      "id": "addr-fr-285",
      "address1": "7 AVENUE HENRI BARBUSSE",
      "city": "Le Blanc Mesnil",
      "state": "Île-de-France",
      "postalCode": "93156",
      "country": "FR"
    },
    "headline": "LABORATOIRE CLEMENT",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.laboratoire-clement.com",
    "email": "arthurc75@gmail.com",
    "phone": "01 45 91 65 41",
    "bookingUrl": null,
    "location": {
      "latitude": 48.9363,
      "longitude": 2.4577899999999318
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-259",
    "name": "RAMSAY SANTÉ - HÔPITAL PRIVÉ DE PARLY II LE CHESNAY",
    "address": {
      "id": "addr-fr-259",
      "address1": "21 RUE MOXOURIS",
      "city": "Le Chesnay",
      "state": "Île-de-France",
      "postalCode": "78150",
      "country": "FR"
    },
    "headline": "RAMSAY SANTÉ - HÔPITAL PRIVÉ DE PARLY II LE CHESNAY",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://hopital-prive-de-parly2-le-chesnay.ramsaysante.fr/master-hp-16",
    "email": "amp@laboratoire-parly2.com",
    "phone": "01 39 63 70 39",
    "bookingUrl": null,
    "location": {
      "latitude": 48.8304,
      "longitude": 2.119959999999992
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-302",
    "name": "CH DE MEAUX",
    "address": {
      "id": "addr-fr-302",
      "address1": "6 RUE SAINT FIACRE",
      "city": "Meaux",
      "state": "Île-de-France",
      "postalCode": "77100",
      "country": "FR"
    },
    "headline": "CH DE MEAUX",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.ghef.fr/",
    "email": "jc.pont@biofutur.eu",
    "phone": "01 78 71 41 51",
    "bookingUrl": null,
    "location": {
      "latitude": 48.9678,
      "longitude": 2.8845999999999776
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-227",
    "name": "CLINIQUE DIACONAT ROOSEVELT",
    "address": {
      "id": "addr-fr-227",
      "address1": "14 BOULEVARD DU PRESIDENT ROOSEVELT",
      "city": "Mulhouse",
      "state": "Île-de-France",
      "postalCode": "68200",
      "country": "FR"
    },
    "headline": "CLINIQUE DIACONAT ROOSEVELT",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.diaconat-mulhouse.fr/specialites/aide-medicale-a-la-procreation/",
    "email": "laboratoire.fiv@diaconat-mulhouse.fr",
    "phone": "03 89 32 55 03",
    "bookingUrl": null,
    "location": {
      "latitude": 47.7494,
      "longitude": 7.330510000000004
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-279",
    "name": "Centre Ambroise Paré (anciennement Pierre Cherest)",
    "address": {
      "id": "addr-fr-279",
      "address1": "5 RUE PIERRE CHEREST",
      "city": "Neuilly Sur Seine",
      "state": "Île-de-France",
      "postalCode": "92200",
      "country": "FR"
    },
    "headline": "Centre Ambroise Paré (anciennement Pierre Cherest)",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.ambroisepare.fr/",
    "email": "ampcherest@eylau.fr",
    "phone": "01 73 06 02 00",
    "bookingUrl": null,
    "location": {
      "latitude": 48.8833,
      "longitude": 2.2799999999999727
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-277",
    "name": "HÔPITAL AMÉRICAIN 2",
    "address": {
      "id": "addr-fr-277",
      "address1": "63 BOULEVARD VICTOR HUGO",
      "city": "Neuilly Sur Seine",
      "state": "Île-de-France",
      "postalCode": "92202",
      "country": "FR"
    },
    "headline": "HÔPITAL AMÉRICAIN 2",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://www.american-hospital.org",
    "email": "fivete_secretariat@ahparis.org",
    "phone": "01 46 41 28 81",
    "bookingUrl": null,
    "location": {
      "latitude": 48.8932,
      "longitude": 2.273490000000038
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-89",
    "name": "HÔPITAL DES DIACONESSES",
    "address": {
      "id": "addr-fr-89",
      "address1": "12 RUE DU SERGENT BAUCHAT",
      "city": "Paris 12eme",
      "state": "Île-de-France",
      "postalCode": "75012",
      "country": "FR"
    },
    "headline": "HÔPITAL DES DIACONESSES",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.hopital-dcss.org/",
    "email": "amp@hopital-dcss.org",
    "phone": "01 44 74 11 15",
    "bookingUrl": null,
    "location": {
      "latitude": 48.8448,
      "longitude": 2.391589999999951
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-251",
    "name": "HOPITAL PIERRE ROUQUES \"LES BLUETS\"",
    "address": {
      "id": "addr-fr-251",
      "address1": "4 RUE LASSON",
      "city": "Paris 12eme",
      "state": "Île-de-France",
      "postalCode": "75012",
      "country": "FR"
    },
    "headline": "HOPITAL PIERRE ROUQUES \"LES BLUETS\"",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.bluets.org/",
    "email": "amp_rv@bluets.org",
    "phone": null,
    "bookingUrl": null,
    "location": {
      "latitude": 48.8431,
      "longitude": 2.4063599999999497
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-243",
    "name": "HU PARIS CENTRE SITE COCHIN APHP",
    "address": {
      "id": "addr-fr-243",
      "address1": "27 RUE DU FAUBOURG SAINT JACQUES",
      "city": "Paris 14eme",
      "state": "Île-de-France",
      "postalCode": "75014",
      "country": "FR"
    },
    "headline": "HU PARIS CENTRE SITE COCHIN APHP",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://hopitaux-paris-centre.aphp.fr/",
    "email": "secret-chefservice.BdR.cch@aphp.fr",
    "phone": "01 58 41 36 71",
    "bookingUrl": null,
    "location": {
      "latitude": 48.8372,
      "longitude": 2.3387199999999666
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-245",
    "name": "INSTITUT MONTSOURIS",
    "address": {
      "id": "addr-fr-245",
      "address1": "42 BOULEVARD JOURDAN",
      "city": "Paris 14eme",
      "state": "Île-de-France",
      "postalCode": "75014",
      "country": "FR"
    },
    "headline": "INSTITUT MONTSOURIS",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://imm.fr/",
    "email": "imm-amp@imm.fr",
    "phone": "01 56 61 61 05",
    "bookingUrl": null,
    "location": {
      "latitude": 48.8219,
      "longitude": 2.3325600000000577
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-249",
    "name": "CLINIQUE DE LA MUETTE",
    "address": {
      "id": "addr-fr-249",
      "address1": "46 RUE NICOLO",
      "city": "Paris 16eme",
      "state": "Île-de-France",
      "postalCode": "75016",
      "country": "FR"
    },
    "headline": "CLINIQUE DE LA MUETTE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://clinique-de-la-muette-paris.ramsaysante.fr/home-page",
    "email": "c.ladire@ramsaygds.fr",
    "phone": "01 40 72 33 33",
    "bookingUrl": null,
    "location": {
      "latitude": 48.8603,
      "longitude": 2.27780000000007
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-247",
    "name": "HU PARIS NORD SITE BICHAT APHP",
    "address": {
      "id": "addr-fr-247",
      "address1": "46 RUE HENRI HUCHARD",
      "city": "Paris 18eme",
      "state": "Île-de-France",
      "postalCode": "75018",
      "country": "FR"
    },
    "headline": "HU PARIS NORD SITE BICHAT APHP",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://hupnvs.aphp.fr/",
    "email": "amp.accueil.bch@aphp.fr",
    "phone": "01 40 25 74 34",
    "bookingUrl": null,
    "location": {
      "latitude": 48.8991,
      "longitude": 2.330850000000055
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-241",
    "name": "HU EST PARISIEN SITE TENON APHP",
    "address": {
      "id": "addr-fr-241",
      "address1": "4 RUE DE LA CHINE",
      "city": "Paris 20eme",
      "state": "Île-de-France",
      "postalCode": "75020",
      "country": "FR"
    },
    "headline": "HU EST PARISIEN SITE TENON APHP",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.fertilite-tenon.fr/",
    "email": "secretariat.fiv@tnn.aphp.fr",
    "phone": "01 56 01 68 69",
    "bookingUrl": null,
    "location": {
      "latitude": 48.8657,
      "longitude": 2.400759999999991
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-257",
    "name": "CHI POISSY ST GERMAIN SITE DE POISSY - SERVICE DE GYNÉCOLOGIE OBSTÉTRIQUE",
    "address": {
      "id": "addr-fr-257",
      "address1": "10 RUE DU CHAMP GAILLARD",
      "city": "Poissy",
      "state": "Île-de-France",
      "postalCode": "78303",
      "country": "FR"
    },
    "headline": "CHI POISSY ST GERMAIN SITE DE POISSY - SERVICE DE GYNÉCOLOGIE OBSTÉTRIQUE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.ghtyvelinesnord.fr/les-etablissements-de-sante/chi-poissy-saint-germain-en-laye/",
    "email": null,
    "phone": "01 39 27 52 52",
    "bookingUrl": null,
    "location": {
      "latitude": 48.9198,
      "longitude": 2.02170000000001
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-275",
    "name": "CH DES QUATRE VILLES SITE ST CLOUD",
    "address": {
      "id": "addr-fr-275",
      "address1": "RUE CHARLES LAUER",
      "city": "Saint Cloud",
      "state": "Île-de-France",
      "postalCode": "92210",
      "country": "FR"
    },
    "headline": "CH DES QUATRE VILLES SITE ST CLOUD",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.ch4v.fr/",
    "email": null,
    "phone": "01 77 70 76 00",
    "bookingUrl": null,
    "location": {
      "latitude": 48.84470014243562,
      "longitude": 2.2178924759037946
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-114",
    "name": "CH GENERAL DELAFONTAINE",
    "address": {
      "id": "addr-fr-114",
      "address1": "2 RUE DU DR DELAFONTAINE",
      "city": "Saint Denis",
      "state": "Île-de-France",
      "postalCode": "93205",
      "country": "FR"
    },
    "headline": "CH GENERAL DELAFONTAINE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.ch-stdenis.fr/",
    "email": "centre.pma@ch-stdenis.fr",
    "phone": "01 42 35 62 12",
    "bookingUrl": null,
    "location": {
      "latitude": 48.9362,
      "longitude": 2.3727800000000343
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-281",
    "name": "HÔPITAL FOCH",
    "address": {
      "id": "addr-fr-281",
      "address1": "40 RUE WORTH",
      "city": "Suresnes",
      "state": "Île-de-France",
      "postalCode": "92151",
      "country": "FR"
    },
    "headline": "HÔPITAL FOCH",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.hopital-foch.com/",
    "email": "rdv.amp@hopital-foch.com",
    "phone": "01 46 25 19 90",
    "bookingUrl": null,
    "location": {
      "latitude": 48.87126860952515,
      "longitude": 2.221939969313888
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-289",
    "name": "HÔPITAL PRIVÉ DE VITRY SITE NORIETS",
    "address": {
      "id": "addr-fr-289",
      "address1": "12 RUE DES NORIETS",
      "city": "Vitry Sur Seine",
      "state": "Île-de-France",
      "postalCode": "94400",
      "country": "FR"
    },
    "headline": "HÔPITAL PRIVÉ DE VITRY SITE NORIETS",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "http://www.hopitalprivedevitry.fr/page-le-site-des-noriets-26.php",
    "email": "laboratoire.vitrypma@biopath-idf.com",
    "phone": "01 46 77 12 14",
    "bookingUrl": null,
    "location": {
      "latitude": 48.7939,
      "longitude": 2.3810700000000224
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-294",
    "name": "BIO SANTÉ CLAIRIÈRE",
    "address": {
      "id": "addr-fr-294",
      "address1": "7 RUE DES HIBISCUS",
      "city": "Fort De France",
      "state": "Martinique",
      "postalCode": "97200",
      "country": "FR"
    },
    "headline": "BIO SANTÉ CLAIRIÈRE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://biosante-martinique.com/",
    "email": null,
    "phone": "05 96 51 85 61 / 05 96 73 73 77",
    "bookingUrl": null,
    "location": {
      "latitude": 14.610730677884563,
      "longitude": -61.07758152327218
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-132",
    "name": "CHU COTE DE NACRE CAEN",
    "address": {
      "id": "addr-fr-132",
      "address1": "AVENUE COTE DE NACRE - Batiment FE",
      "city": "Caen",
      "state": "Normandie",
      "postalCode": "14033",
      "country": "FR"
    },
    "headline": "CHU COTE DE NACRE CAEN",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chu-caen.fr/page.php?idpage=54",
    "email": "secretariat-amp@chu-caen.fr",
    "phone": "02 31 27 26 63",
    "bookingUrl": null,
    "location": {
      "latitude": 49.2004,
      "longitude": -0.36093000000005304
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-195",
    "name": "POLYCLINIQUE DU COTENTIN",
    "address": {
      "id": "addr-fr-195",
      "address1": "50 AVENUE THIVET",
      "city": "Equeurdreville-Hainneville",
      "state": "Normandie",
      "postalCode": "50120",
      "country": "FR"
    },
    "headline": "POLYCLINIQUE DU COTENTIN",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.polyclinique-cotentin.fr",
    "email": "secretariat.polyclinique@unilabs.com",
    "phone": "02 33 78 51 52",
    "bookingUrl": null,
    "location": {
      "latitude": 49.6377,
      "longitude": -1.667889999999943
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-317",
    "name": "CENTRE DE L'EURE - CENTRE HOSPITALIER EURE-SEINE D'EVREUX",
    "address": {
      "id": "addr-fr-317",
      "address1": "RUE LEON SCHWARTZENBERG",
      "city": "Evreux",
      "state": "Normandie",
      "postalCode": "27015",
      "country": "FR"
    },
    "headline": "CENTRE DE L'EURE - CENTRE HOSPITALIER EURE-SEINE D'EVREUX",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.hopital.fr/annuaire-service/gynecologie-evreux-centre-hospitalier-eure-seine-hopital-d-evreux-vernon-evreux,43931",
    "email": "gynecoevreux@ch-eureseine.fr",
    "phone": "02 32 33 80 87",
    "bookingUrl": null,
    "location": {
      "latitude": 49.03266346058346,
      "longitude": 1.116511176727811
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-255",
    "name": "GROUPE HOSPITALIER DU HAVRE - HOPITAL JACQUES MONOD",
    "address": {
      "id": "addr-fr-255",
      "address1": "29 RUE PIERRE MENDES FRANCE",
      "city": "Montivilliers",
      "state": "Normandie",
      "postalCode": "76290",
      "country": "FR"
    },
    "headline": "GROUPE HOSPITALIER DU HAVRE - HOPITAL JACQUES MONOD",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.ch-havre.fr/",
    "email": "sec.amp@ch-havre.fr",
    "phone": "02 32 73 33 35",
    "bookingUrl": null,
    "location": {
      "latitude": 49.5124,
      "longitude": 0.14877899999999045
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-99",
    "name": "CENTRE AMP DE LA CLINIQUE MATHILDE",
    "address": {
      "id": "addr-fr-99",
      "address1": "7 BOULEVARD DE L'EUROPE",
      "city": "Rouen",
      "state": "Normandie",
      "postalCode": "76175",
      "country": "FR"
    },
    "headline": "CENTRE AMP DE LA CLINIQUE MATHILDE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.amp-mathilde76.fr",
    "email": "sandrine.laroche@clinique-mathilde.fr",
    "phone": "02 76 64 10 80",
    "bookingUrl": null,
    "location": {
      "latitude": 49.4285,
      "longitude": 1.0949100000000271
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-253",
    "name": "HÔPITAL CHARLES NICOLLE CHU ROUEN",
    "address": {
      "id": "addr-fr-253",
      "address1": "37 BOULEVARD GAMBETTA",
      "city": "Rouen",
      "state": "Normandie",
      "postalCode": "76000",
      "country": "FR"
    },
    "headline": "HÔPITAL CHARLES NICOLLE CHU ROUEN",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chu-rouen.fr/",
    "email": "amp.gynecologie@chu-rouen.fr",
    "phone": "02 32 88 82 70",
    "bookingUrl": null,
    "location": {
      "latitude": 49.43883585215296,
      "longitude": 1.1108255831626384
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-223",
    "name": "RAMSAY SANTÉ",
    "address": {
      "id": "addr-fr-223",
      "address1": "2 ALLÉE DU DOCTEUR LAFON",
      "city": "Bayonne",
      "state": "Nouvelle-Aquitaine",
      "postalCode": "64100",
      "country": "FR"
    },
    "headline": "RAMSAY SANTÉ",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://clinique-belharra-bayonne.ramsaysante.fr/master-hp-belharra",
    "email": "l.trebess@axbioocean.fr",
    "phone": "05 36 28 64 64",
    "bookingUrl": null,
    "location": {
      "latitude": 43.4793,
      "longitude": -1.4537699999999631
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-159",
    "name": "CENTRE AMP GROUPE HOSPITALIER PELLEGRIN CHU",
    "address": {
      "id": "addr-fr-159",
      "address1": "PLACE AMELIE RABA LEON",
      "city": "Bordeaux",
      "state": "Nouvelle-Aquitaine",
      "postalCode": "33076",
      "country": "FR"
    },
    "headline": "CENTRE AMP GROUPE HOSPITALIER PELLEGRIN CHU",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.chu-bordeaux.fr/",
    "email": null,
    "phone": "05 56 79 56 81",
    "bookingUrl": null,
    "location": {
      "latitude": 44.83,
      "longitude": -0.603601000000026
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-157",
    "name": "CENTRE DE LA MÉDECINE DE LA REPRODUCTION CLINIQUE JEAN VILLAR",
    "address": {
      "id": "addr-fr-157",
      "address1": "AVENUE MARYSE BASTIE",
      "city": "Bruges",
      "state": "Nouvelle-Aquitaine",
      "postalCode": "33523",
      "country": "FR"
    },
    "headline": "CENTRE DE LA MÉDECINE DE LA REPRODUCTION CLINIQUE JEAN VILLAR",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.fivbordeaux.com",
    "email": "centrefiv@aquitainesante.fr",
    "phone": "05 56 16 80 10",
    "bookingUrl": null,
    "location": {
      "latitude": 44.8881,
      "longitude": -0.6151909999999816
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-134",
    "name": "Centre de fertilité de La Rochelle - Clinique de l'Atlantique",
    "address": {
      "id": "addr-fr-134",
      "address1": "26 rue moulin des justices",
      "city": "La Rochelle",
      "state": "Nouvelle-Aquitaine",
      "postalCode": "17138",
      "country": "FR"
    },
    "headline": "Centre de fertilité de La Rochelle - Clinique de l'Atlantique",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "http://fertilite-larochelle.com/",
    "email": null,
    "phone": "05 46 00 98 98",
    "bookingUrl": null,
    "location": {
      "latitude": 46.1741672,
      "longitude": -1.1285404
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-269",
    "name": "HÔPITAL DE LA MÈRE ET DE L'ENFANT - CENTRE PMA",
    "address": {
      "id": "addr-fr-269",
      "address1": "8 AVENUE DOMINIQUE LARREY",
      "city": "Limoges",
      "state": "Nouvelle-Aquitaine",
      "postalCode": "87042",
      "country": "FR"
    },
    "headline": "HÔPITAL DE LA MÈRE ET DE L'ENFANT - CENTRE PMA",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://www.chu-limoges.fr/",
    "email": "cecos@chu-limoges.fr",
    "phone": "05 55 05 64 72",
    "bookingUrl": null,
    "location": {
      "latitude": 45.8131,
      "longitude": 1.240790000000061
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-221",
    "name": "POLYCLINIQUE DE NAVARRE",
    "address": {
      "id": "addr-fr-221",
      "address1": "8 BOULEVARD HAUTERIVE",
      "city": "Pau",
      "state": "Nouvelle-Aquitaine",
      "postalCode": "64075",
      "country": "FR"
    },
    "headline": "POLYCLINIQUE DE NAVARRE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.biopyrenees.com",
    "email": "centrefivpau@gmail.com",
    "phone": "05 59 14 54 54",
    "bookingUrl": null,
    "location": {
      "latitude": 43.3237,
      "longitude": -0.35018700000000536
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-138",
    "name": "CENTRE DE BIOLOGIE MEDICALE NOVABIO POLYCLINIQUE FRANCHEVILLE",
    "address": {
      "id": "addr-fr-138",
      "address1": "34 BOULEVARD DE VESONE",
      "city": "Perigueux",
      "state": "Nouvelle-Aquitaine",
      "postalCode": "24004",
      "country": "FR"
    },
    "headline": "CENTRE DE BIOLOGIE MEDICALE NOVABIO POLYCLINIQUE FRANCHEVILLE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.novabio.fr",
    "email": "cbm.guynemer@novabio.fr",
    "phone": "05 53 45 65 10",
    "bookingUrl": null,
    "location": {
      "latitude": 45.1814,
      "longitude": 0.7170800000000099
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-267",
    "name": "CHU DE POITIERS - LA MILETRIE",
    "address": {
      "id": "addr-fr-267",
      "address1": "2 RUE DE LA MILETRIE",
      "city": "Poitiers",
      "state": "Nouvelle-Aquitaine",
      "postalCode": "86021",
      "country": "FR"
    },
    "headline": "CHU DE POITIERS - LA MILETRIE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chu-poitiers.fr/",
    "email": "sec.amp@chu-poitiers.fr",
    "phone": "05 49 44 39 56",
    "bookingUrl": null,
    "location": {
      "latitude": 46.56,
      "longitude": 0.38236800000004223
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-163",
    "name": "POLYCLINIQUE ST ROCH",
    "address": {
      "id": "addr-fr-163",
      "address1": "560 AVENUE DU COLONEL ANDRE PAVELET",
      "city": "Montpellier",
      "state": "Occitanie",
      "postalCode": "34075",
      "country": "FR"
    },
    "headline": "POLYCLINIQUE ST ROCH",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.oc-sante.fr/",
    "email": null,
    "phone": "04 67 52 00 42",
    "bookingUrl": null,
    "location": {
      "latitude": 43.5821,
      "longitude": 3.863299999999981
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-161",
    "name": "HÔPITAL ARNAUD DE VILLENEUVE CHU MPT",
    "address": {
      "id": "addr-fr-161",
      "address1": "371 AVENUE DU DOYEN GASTON GIRAUD",
      "city": "MONTPELLIER Cedex 5",
      "state": "Occitanie",
      "postalCode": "34295",
      "country": "FR"
    },
    "headline": "HÔPITAL ARNAUD DE VILLENEUVE CHU MPT",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs",
      "PGT"
    ],
    "website": "https://www.chu-montpellier.fr/fr/a-propos-du-chu/decouvrir/etablissements/arnaud-de-villeneuve",
    "email": "bio-dev-repro-sec@chu-montpellier.fr",
    "phone": "04 67 33 65 36",
    "bookingUrl": null,
    "location": {
      "latitude": 43.6298921,
      "longitude": 3.8519874
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-150",
    "name": "CHU NÎMES CAREMEAU - GYNECOLOGIE AMP",
    "address": {
      "id": "addr-fr-150",
      "address1": "PLACE DU PROFESSEUR ROBERT DEBRE",
      "city": "Nimes",
      "state": "Occitanie",
      "postalCode": "30029",
      "country": "FR"
    },
    "headline": "CHU NÎMES CAREMEAU - GYNECOLOGIE AMP",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.centre-amp-nimes.fr/",
    "email": "sec.amp@chu-nimes.fr",
    "phone": "04 66 68 32 20",
    "bookingUrl": null,
    "location": {
      "latitude": 43.8225,
      "longitude": 4.318629999999985
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-75",
    "name": "CLINIQUE ST PIERRE",
    "address": {
      "id": "addr-fr-75",
      "address1": "169 AVENUE DE PRADES",
      "city": "Perpignan",
      "state": "Occitanie",
      "postalCode": "66012",
      "country": "FR"
    },
    "headline": "CLINIQUE ST PIERRE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.elsan.care/fr/clinique-saint-pierre",
    "email": "consultation.pma@biopole66.com",
    "phone": "04 68 56 28 35",
    "bookingUrl": null,
    "location": {
      "latitude": 42.6961,
      "longitude": 2.8647399999999834
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-154",
    "name": "INSTITUT DE FERTILITE LA CROIX-DU-SUD",
    "address": {
      "id": "addr-fr-154",
      "address1": "52 bis, chemin de Ribaute",
      "city": "Quint-Fonsegrives",
      "state": "Occitanie",
      "postalCode": "31130",
      "country": "FR"
    },
    "headline": "INSTITUT DE FERTILITE LA CROIX-DU-SUD",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://pma-toulouse.fr/",
    "email": "Chantal.catanese@cbm-laboratoires.fr",
    "phone": "05.32.02.71.17",
    "bookingUrl": null,
    "location": {
      "latitude": 43.58350896563209,
      "longitude": 1.5082904153455623
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-152",
    "name": "CENTRE AMP HÔPITAUX MÈRE ENFANTS SITE VIGUIER",
    "address": {
      "id": "addr-fr-152",
      "address1": "330 AVENUE DE GRANDE BRETAGNE PSA 70034",
      "city": "Toulouse Cedex 9",
      "state": "Occitanie",
      "postalCode": "31059",
      "country": "FR"
    },
    "headline": "CENTRE AMP HÔPITAUX MÈRE ENFANTS SITE VIGUIER",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.chu-toulouse.fr",
    "email": "amp-secretariat@chu-toulouse.fr",
    "phone": "05 67 77 11 02",
    "bookingUrl": null,
    "location": {
      "latitude": 43.6062,
      "longitude": 1.4017900000000054
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-193",
    "name": "CHU D'ANGERS : SITE LARREY",
    "address": {
      "id": "addr-fr-193",
      "address1": "4 RUE LARREY",
      "city": "Angers",
      "state": "Pays de la Loire",
      "postalCode": "49933",
      "country": "FR"
    },
    "headline": "CHU D'ANGERS : SITE LARREY",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chu-angers.fr/",
    "email": "amp@chu-angers.fr",
    "phone": "02 41 35 42 13",
    "bookingUrl": null,
    "location": {
      "latitude": 47.4811,
      "longitude": -0.5544830000000047
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-265",
    "name": "CENTRE PROCREALIS - SITE DE LA CLINIQUE SAINT CHARLES",
    "address": {
      "id": "addr-fr-265",
      "address1": "11 BOULEVARD RENE LEVESQUE",
      "city": "La Roche Sur Yon",
      "state": "Pays de la Loire",
      "postalCode": "85016",
      "country": "FR"
    },
    "headline": "CENTRE PROCREALIS - SITE DE LA CLINIQUE SAINT CHARLES",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "http://www.procrealis.com",
    "email": "info@procrealis.com",
    "phone": "02 51 44 10 60",
    "bookingUrl": null,
    "location": {
      "latitude": 46.6587,
      "longitude": -1.4132099999999355
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-237",
    "name": "CLINIQUE DU POLE SANTÉ SUD",
    "address": {
      "id": "addr-fr-237",
      "address1": "62 RUE DE GUETTELOUP",
      "city": "Le Mans",
      "state": "Pays de la Loire",
      "postalCode": "72100",
      "country": "FR"
    },
    "headline": "CLINIQUE DU POLE SANTÉ SUD",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "http://www.polesantesud.fr",
    "email": "direction@polesantesud.fr",
    "phone": "02 43 78 58 58",
    "bookingUrl": null,
    "location": {
      "latitude": 47.9666,
      "longitude": 0.2240590000000111
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-187",
    "name": "CLINIQUE J.VERNE POLE HOSP MUTUALISTE",
    "address": {
      "id": "addr-fr-187",
      "address1": "2 ROUTE DE PARIS",
      "city": "Nantes",
      "state": "Pays de la Loire",
      "postalCode": "44314",
      "country": "FR"
    },
    "headline": "CLINIQUE J.VERNE POLE HOSP MUTUALISTE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.cliniquejulesverne.fr/",
    "email": "amp.julesverne@hospigrandouest.fr",
    "phone": "02 51 17 15 30",
    "bookingUrl": null,
    "location": {
      "latitude": 47.2488,
      "longitude": -1.5207000000000335
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-181",
    "name": "CHU DE NANTES : SERVICE BIOLOGIE ET DE LA REPRODUCTION",
    "address": {
      "id": "addr-fr-181",
      "address1": "38 BOULEVARD JEAN-MONNET",
      "city": "Nantes Cedex 1",
      "state": "Pays de la Loire",
      "postalCode": "44093",
      "country": "FR"
    },
    "headline": "CHU DE NANTES : SERVICE BIOLOGIE ET DE LA REPRODUCTION",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs",
      "PGT"
    ],
    "website": "http://www.chu-nantes.fr/etablissements-du-chu-hopital-femme-enfant-adolescent-11326.kjsp?RH=ACCUEIL",
    "email": null,
    "phone": "02 40 08 32 33",
    "bookingUrl": null,
    "location": {
      "latitude": 47.21017815649035,
      "longitude": -1.550888884654438
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-183",
    "name": "ACCUEIL DE GYNECOLOGIE OBSTRÉTRIQUE SANTÉ ATLANTIQUE",
    "address": {
      "id": "addr-fr-183",
      "address1": "AVENUE CLAUDE BERNARD",
      "city": "Saint Herblain",
      "state": "Pays de la Loire",
      "postalCode": "44819",
      "country": "FR"
    },
    "headline": "ACCUEIL DE GYNECOLOGIE OBSTRÉTRIQUE SANTÉ ATLANTIQUE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://www.pmatlantique.fr",
    "email": "accueilpma@polyclinique-atlantique.fr",
    "phone": "02 40 95 94 72",
    "bookingUrl": null,
    "location": {
      "latitude": 47.2264,
      "longitude": -1.6129100000000562
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-130",
    "name": "CENTRE HOSPITALIER SITE D'AIX EN PROVENCE",
    "address": {
      "id": "addr-fr-130",
      "address1": "AVENUE DES TAMARIS",
      "city": "Aix En Provence",
      "state": "Provence-Alpes-Côte d'Azur",
      "postalCode": "13616",
      "country": "FR"
    },
    "headline": "CENTRE HOSPITALIER SITE D'AIX EN PROVENCE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.ch-aix.fr/",
    "email": "secretariat-pma@ch-aix.fr",
    "phone": "04 42 33 55 65",
    "bookingUrl": null,
    "location": {
      "latitude": 43.5358,
      "longitude": 5.440740000000005
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-263",
    "name": "ELSAN POLYCLINIQUE URBAIN V",
    "address": {
      "id": "addr-fr-263",
      "address1": "47 CHEMIN DU PONT DES DEUX EAUX",
      "city": "Avignon",
      "state": "Provence-Alpes-Côte d'Azur",
      "postalCode": "84000",
      "country": "FR"
    },
    "headline": "ELSAN POLYCLINIQUE URBAIN V",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.elsan.care/fr/polyclinique-urbainv",
    "email": "cliniqueurbainv.sd@free.fr",
    "phone": "04 90 81 31 33",
    "bookingUrl": null,
    "location": {
      "latitude": 43.9456,
      "longitude": 4.841819999999984
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-124",
    "name": "APHM HÔPITAL DE LA CONCEPTION",
    "address": {
      "id": "addr-fr-124",
      "address1": "147 BOULEVARD BAILLE - Bâtiment F",
      "city": "Marseille 5eme",
      "state": "Provence-Alpes-Côte d'Azur",
      "postalCode": "13005",
      "country": "FR"
    },
    "headline": "APHM HÔPITAL DE LA CONCEPTION",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "http://fr.ap-hm.fr/category/disciplines/aide-medicale-a-la-procreation",
    "email": "ampconception@ap-hm.fr",
    "phone": "04 91 38 37 11 (04 91 38 29 00 CECOS pour la conservation )",
    "bookingUrl": null,
    "location": {
      "latitude": 43.2895,
      "longitude": 5.396489999999972
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-128",
    "name": "CLINIQUE BOUCHARD",
    "address": {
      "id": "addr-fr-128",
      "address1": "77 RUE DU DOCTEUR ESCAT",
      "city": "Marseille 6eme",
      "state": "Provence-Alpes-Côte d'Azur",
      "postalCode": "13006",
      "country": "FR"
    },
    "headline": "CLINIQUE BOUCHARD",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.imr-marseille.com",
    "email": "bouchard.marseille@elsan.care",
    "phone": "04 91 15 90 21",
    "bookingUrl": null,
    "location": {
      "latitude": 43.2828,
      "longitude": 5.379519999999957
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-126",
    "name": "HÔPITAL SAINT JOSEPH",
    "address": {
      "id": "addr-fr-126",
      "address1": "26 BOULEVARD DE LOUVAIN",
      "city": "Marseille 8eme",
      "state": "Provence-Alpes-Côte d'Azur",
      "postalCode": "13008",
      "country": "FR"
    },
    "headline": "HÔPITAL SAINT JOSEPH",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.hopital-saint-joseph.fr/",
    "email": "umrsec@hopital-saint-joseph.fr",
    "phone": "04 91 80 64 70",
    "bookingUrl": null,
    "location": {
      "latitude": 43.2763,
      "longitude": 5.3924899999999525
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-17",
    "name": "CLINIQUE SAINT GEORGE",
    "address": {
      "id": "addr-fr-17",
      "address1": "2 AVENUE DE RIMIEZ",
      "city": "Nice",
      "state": "Provence-Alpes-Côte d'Azur",
      "postalCode": "06105",
      "country": "FR"
    },
    "headline": "CLINIQUE SAINT GEORGE",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.clinique-saint-george.com/nos-specialites/medecine/centre-pma/",
    "email": "contact.fiv@eurofins-biologie.com",
    "phone": "04 92 26 77 79",
    "bookingUrl": null,
    "location": {
      "latitude": 43.7334,
      "longitude": 7.277479999999969
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-14",
    "name": "HOPITAL DE L'ARCHET",
    "address": {
      "id": "addr-fr-14",
      "address1": "151 ROUTE SAINT ANTOINE DE GINESTIERE",
      "city": "Nice",
      "state": "Provence-Alpes-Côte d'Azur",
      "postalCode": "06200",
      "country": "FR"
    },
    "headline": "HOPITAL DE L'ARCHET",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing",
      "Donor programs"
    ],
    "website": "https://www.chu-nice.fr/nos-hopitaux/hopital-larchet",
    "email": "centre-de-reproduction@chu-nice.fr",
    "phone": "04 92 03 64 03",
    "bookingUrl": null,
    "location": {
      "latitude": 43.7055,
      "longitude": 7.216890000000035
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.991Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  },
  {
    "id": "fr-1827",
    "name": "Centre d'Assistance Médicale à la Procréation St-Jean - Clinique St-Jean Hôpital Privé Toulon Hyères",
    "address": {
      "id": "addr-fr-1827",
      "address1": "1 av Henri Dunant",
      "city": "Toulon",
      "state": "Provence-Alpes-Côte d'Azur",
      "postalCode": "83000",
      "country": "FR"
    },
    "headline": "Centre d'Assistance Médicale à la Procréation St-Jean - Clinique St-Jean Hôpital Privé Toulon Hyères",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["fr"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Embryo Freezing",
      "Egg Freezing",
      "Sperm Freezing"
    ],
    "website": "https://www.hpth-saint-jean.fr/",
    "email": "laboamptoulonsaintjean@cerballiance.fr",
    "phone": "04.88.68.55.08",
    "bookingUrl": null,
    "location": {
      "latitude": 43.12385070654829,
      "longitude": 5.94711760091928
    },
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "ABM",
    "lastReportYear": 2026,
    "publicNotes": null,
    "lastUpdatedIso": "2026-06-11T10:25:24.990Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null
  }
]
